import { H4, Radio, RadioGroup } from "@blueprintjs/core"
import { ChangeEvent, useCallback, useState } from "react"

import { FlexContainer } from "../../../../styled/flexbox.styled"
import { DatasetFilters, DatasetSource } from "./types"

interface ISourceFilterProps {
  filters: DatasetFilters
  onFilterChange: (filters: { sourceParam?: DatasetSource }) => void
}

const SourceFilter = ({ filters, onFilterChange }: ISourceFilterProps) => {
  const handleSourceChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.currentTarget.value as DatasetSource | undefined
      onFilterChange({ sourceParam: value || undefined })
    },
    [onFilterChange],
  )

  return (
    <FlexContainer flexDirection="row" gap="10px">
      <H4>Source</H4>
      <RadioGroup
        onChange={handleSourceChange}
        selectedValue={filters.sourceParam || ""}
        inline={true}
      >
        <Radio label="All" value={""} />
        <Radio label="Internal" value="internal" />
        <Radio label="Bloomberg" value="bloomberg" />
      </RadioGroup>
    </FlexContainer>
  )
}

export default SourceFilter
